<sp-avatar *ngIf="spUser" [user]="spUser" [size]="avatarSize" [fontSize]="avatarFontSize" [showToolTip]="showNameToolTip" [clickable]="false"></sp-avatar>
<div *ngIf="!isOtherUser" class="ml-10 mt-5 flex items-center">
  <input type="file" accept=".png, .jpg, .jpeg" #file class="hidden" (change)="fileBrowseHandler($event)" />
  <button [disabled]="disableUpload" mat-flat-button class="button-primary mr-4" [ngClass]="{ 'text-black opacity-[0.26]': disableUpload }" type="button" (click)="file.click()">
    <mat-icon class="material-icons-outlined mr-2">cloud_upload</mat-icon>
    <ng-container i18n>Upload new image</ng-container>
  </button>
  <button
    *ngIf="brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge"
    [disabled]="disableUpload"
    mat-flat-button
    class="button-primary"
    [ngClass]="{ 'text-black opacity-[0.26]': disableUpload }"
    type="button"
    (click)="deleteUserAccount()"
  >
    <mat-icon class="material-icons-outlined mr-2">delete</mat-icon>
    <ng-container i18n>Delete account</ng-container>
  </button>
  <mat-spinner *ngIf="uploadInProgress" class="ml-10" [diameter]="20"></mat-spinner>
</div>
